import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { AnimationContents } from "../../../../AnimationContents";
import { PropsLogic } from "../../../Logic/MiniGames/PropsLogic";
import { PropsModel } from "../../../Models/MiniGames/PropsModel";

export interface IPropsBarOptions{

}

export class PropsBarController extends AnimationBaseController {
    public $model: PropsModel;
    constructor(
        @Inject private options: IPropsBarOptions,
        @Inject private logic: PropsLogic,
    )
    {
        super("PropsBarController");
    }

    public getConfiguration() : IAnimationControllerConfiguration{
        return {
            animationContent: AnimationContents.PROPS_PROGRESSBAR_JSON,
            libraryName: "progress_bar_ship",
            modelWatch: {
                step : (step)=>{
                    console.log("step", step);
                    this.gotoAndStop(step+"");
                    // this.gotoAndStopByQuery("progress_bar_mini_game", 1);
                }
            }
        }
    }

    public onResize(width: number, height: number, scale: number){
        console.log(this);
        this.y = -580 +0;
    }

    onInitialize(){
        this.gotoAndStop(1);
    }
}